import React from 'react';
import { render } from 'react-dom';
import ProgressHeader from '@updater-core/uds/components/ProgressHeader';
import classes from './progress-header.module.css';

export default class Progress extends HTMLElement {
  connectedCallback() {
    /* 
      The progress header includes top-padding
      Since FYM uses breadcrumbs at top this creates too much space
      We can offset this by pulling the component wrapper up
      by -16px
    */

    this.style.display = 'block';
    this.style.marginTop = '-16px';

    render(
      <ProgressHeader
        className={classes.progressHeader}
        progress={Number(this.getAttribute('progress'))}
        totalSteps={Number(this.getAttribute('total-steps'))}
        title={this.getAttribute('title')}
        onBack={
          this.getAttribute('show-back') &&
          (() => this.dispatchEvent(new Event('back', { bubbles: true })))
        }
      />,
      this
    );
  }
}

customElements.define('upd-fym-progress-header', Progress);
